export default __webpack_public_path__ + "62b92ec4d2ce35de25161c71a94e1ddc.svg";